// A sliding highlight behind the active item of a segmented control (the
// editor's size, mode and panel switches, and the inspector's choices): it
// moves to the chosen item instead of jumping. The items keep their text; the
// glide paints the white tile. Items take part with data-glide-item.
import { useEffect, useLayoutEffect, useRef, useState } from 'react';

export function SegGlide({ active }: { active: number }) {
  const ref = useRef<HTMLSpanElement>(null);
  const [box, setBox] = useState<{ x: number; w: number } | null>(null);
  // The first placement never slides in from the left edge.
  const [ready, setReady] = useState(false);
  useLayoutEffect(() => {
    const parent = ref.current?.parentElement;
    if (!parent) return;
    const measure = () => {
      const item = parent.querySelectorAll<HTMLElement>(':scope > [data-glide-item]')[active];
      if (!item || !item.offsetWidth) return;
      setBox((b) => (b && b.x === item.offsetLeft && b.w === item.offsetWidth ? b : { x: item.offsetLeft, w: item.offsetWidth }));
    };
    measure();
    if (typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(measure);
    ro.observe(parent);
    return () => ro.disconnect();
  }, [active]);
  useEffect(() => {
    if (!box || ready) return;
    const t = requestAnimationFrame(() => setReady(true));
    return () => cancelAnimationFrame(t);
  }, [box, ready]);
  return (
    <span ref={ref} aria-hidden data-glide className={`pe-glide${ready ? ' is-ready' : ''}`}
      style={box ? { width: box.w, transform: `translateX(${box.x}px)` } : { opacity: 0 }} />
  );
}
